import { render, staticRenderFns } from "./DOOutstandingPerProduct.vue?vue&type=template&id=1871b5a5"
import script from "./DOOutstandingPerProduct.vue?vue&type=script&lang=js"
export * from "./DOOutstandingPerProduct.vue?vue&type=script&lang=js"
import style0 from "./DOOutstandingPerProduct.vue?vue&type=style&index=0&id=1871b5a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports